import React from 'react'
import {
  Box,
  TextField,
  Grid,
} from '@mui/material'
import { Controller } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'

export interface VehicleMediaFormData {
  id?: string | null
  make: string
  model: string
  trim: string
  year: number
  data: string
}

interface VehicleMediaFormProps {
  errors: any
  control: any
}

export const VehicleMediaForm: React.FC<VehicleMediaFormProps> = ({
  errors,
  control,
}) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Grid container spacing={2}>
        {typeof control?._formValues?.id !== 'undefined' && control._formValues.id !== null && (
        <Grid style={{ display: 'none' }}>
          <Controller
            name="id"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                type="hidden"
              />
            )}
          />
        </Grid>
          )}
        <Grid size={{xs:12, md:6}}>
          <Controller
            name="make"
            control={control}
            rules={{ required: 'Make is required' }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="Make"
                error={!!errors.make}
                helperText={<ErrorMessage errors={errors} name="make" />}
              />
            )}
          />
        </Grid>

        <Grid size={{xs:12, md:6}}>
          <Controller
            name="model"
            control={control}
            rules={{ required: 'Model is required' }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="Model"
                error={!!errors.model}
                helperText={<ErrorMessage errors={errors} name="model" />}
              />
            )}
          />
        </Grid>

        <Grid size={{xs:12, md:6}}>
          <Controller
            name="year"
            control={control}
            rules={{
              required: 'Year is required',
              min: { value: 1900, message: 'Year must be after 1900' },
              max: { value: new Date().getFullYear() + 5, message: 'Year cannot be too far in future' }
            }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="Year"
                type="number"
                error={!!errors.year}
                helperText={<ErrorMessage errors={errors} name="year" />}
              />
            )}
          />
        </Grid>

        <Grid size={{xs:12, md:6}}>
          <Controller
            name="trim"
            control={control}
            rules={{ required: 'Trim is required' }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="Trim"
                error={!!errors.trim}
                helperText={<ErrorMessage errors={errors} name="trim" />}
              />
            )}
          />
        </Grid>

        <Grid size={{xs:12}}>
          <Controller
            name="data"
            control={control}
            rules={{ required: 'Data is required' }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="Data"
                multiline
                rows={4}
                error={!!errors.data}
                helperText={<ErrorMessage errors={errors} name="data" />}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
